import en from './en.json';

export default en;

declare global {
  interface RegisteredLocales {
    common: typeof en;
  }
}
